<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
<style lang="scss">
@import "~bootstrap/dist/css/bootstrap.css";
@import "./assets/scss/app.scss";
#app {
  /* background: linear-gradient(180deg, #ffffff 0%, #e9eff5 100%) !important; */

  font-family: "Sukhumvit";
}
@font-face {
  font-family: "Sukhumvit";
  src: url(./fonts/SukhumvitSet-Medium.ttf);
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Sukhumvit";
  src: url(./fonts/SukhumvitSet-SemiBold.ttf);
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Sukhumvit";
  src: url(./fonts/SukhumvitSet-Bold.ttf);
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Sukhumvit";
  src: url(./fonts/SukhumvitSet-Light.ttf);
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Sukhumvit";
  src: url(./fonts/SukhumvitSet-Text.ttf);
  font-style: normal;
  font-weight: 400;
}
/* .rsu {
  font-family: "rsu", sans-serif !important;
}

.Montserrat {
  font-family: "Montserrat", sans-serif !important;
}

.Kanit {
  font-family: "Kanit", sans-serif !important;
} */

.swal2-modal {
  font-family: "Montserrat", "Kanit", sans-serif !important;
}
.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}

/* @font-face {
  font-family: "rsu";
  src: url("../fonts/ComicNeue-Light.eot");

  src: url("../fonts/ComicNeue-Light.eot?#iefix") format("embedded-opentype"),
 url("../fonts/ComicNeue-Light.woff") format("woff"),
 url("../fonts/ComicNeue-Light.ttf") format("truetype");

  font-weight: 100;
} */
</style>
